import React from 'react';
import Header from '../Header';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import * as api from '../../../../api';

const ThanksContainer = styled.div`
    width:100%;
    padding-top:40px;
    display:flex;
    flex-direction:column;
    justify-content: space-between;
    text-align:center;
    margin-bottom: 40px;
    margin-left: 20px;
    row-gap: 20px;
    align-items:center ;
    padding-bottom:40px;

    & h2{
        width:100%;
        margin-right:0;
    }

    & p {
        width:50%;
    }
`;

const Thanks = () => {
    const navigate = useNavigate();

    const { i18n } = useTranslation('common');
    const [event, setEvent] = React.useState(null);

    //parse eid from url and get event
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    function gotoevent() {
        navigate('/evenements')
    }

    const poptype = new URLSearchParams(window.location.search).get("pop");

    return (
        <div>
            <Header />
            <ThanksContainer>
                {poptype === "b" ? <>{i18n.language === "fr" ? <>
                    <h2>Merci pour votre candidature au {event?.title_fr}</h2>
                    <p>Un email récapitulatif vous a été envoyé sur votre adresse email.</p>
                </> : <>
                    <h2>THANK YOU FOR REGISTERING TO {event?.title_en}</h2>
                    <p>A recap email has been sent to your email address.</p>
                </>}</> : <>{i18n.language === "fr" ? <>
                    <h2>Merci pour votre inscription au {event?.title_fr}</h2>
                    <p>Un email de confirmation vous a été envoyé sur votre adresse email.</p>
                </> : <>
                    <h2>THANK YOU FOR REGISTERING TO {event?.title_en}</h2>
                    <p>A confirmation email has been sent to your email address.</p>
                </>}</>}
                {poptype === "b" && <>
                    <p>{i18n.language === "fr" ? 'Vous avez la possibilité de modifier vos réponses jusqu’à 7 jours avant la tenue du Speed Dating en vous connectant sur votre compte à partir du site connectedby.lefrenchdesign.org, ou via le mail récapitulatif que vous avez reçu (pensez à vérifier dans vos spams).' : 'You have the possibility to modify your answers until 7 days before the Speed Dating by logging into your account from the site connected by lefrenchdesign.org or via the confirmation email you received. (check your spam folder)'}</p>
                </>}
                {/* {poptype === "b" && <>
                    <p>{i18n.language === "fr" ? "N'oubliez-pas de prioriser vos choix d'architectes, architectes d'intérieurs, prescripteurs, donneurs d'ordre, pour finaliser votre inscription." : "Don't forget to prioritize your choices of architects, interior designers, specifiers, principals, to finalize your registration."}</p>
                </>} */}
                <button onClick={gotoevent}>{i18n.language === "fr" ? 'Mes évènements' : 'My events'}</button>
            </ThanksContainer>
        </div>
    );
};

export default Thanks;